<template>
    <card-seplag titulo="Direitos Não Agendados" cor="#00acc1" >
        <table-seplag :dados.sync="dadosTabelaNaoValidados" :paginacao="true" :exibirCabecalho="false" :campos="colunasTabela" :urlPanagicao="urlPaginacao" 
                      :linhas="tamanhoPorpagina" :totalRegistro.sync="totalRegistro" :queryPagina.sync="paginacaoTabela">
            
            <Column  headerStyle="width: 14em" bodyStyle="text-align: center" header="Período Aquisitivo">
                <template field="dataInicio" #body="slotProps"> 
                        <span>{{slotProps.data.dataInicio}} à {{slotProps.data.dataFim}}</span>                       
                    </template>
            </Column>
            <Column  headerStyle="width: 15em" bodyStyle="text-align: center" header="Dias de Direito">
                <template field="saldoDias" #body="slotProps"> 
                    <span>{{slotProps.data.saldoDias}} dias <br></span>                 
                    <span v-if="slotProps.data.tipoJornada && slotProps.data.tipoJornada=='REDUZIDA'">(<b>Redução de Jornada</b>)<br></span>
                    <span v-if="slotProps.data.tipoJornada && slotProps.data.tipoJornada=='INTEGRAL'">(<b>Usufruto</b>)<br></span>
                    <span><b>{{slotProps.data.title}}</b><br></span>
                </template>
            </Column>
            <Column headerStyle="width: 12em" bodyStyle="text-align: center" header="Status">
                    <template #body="slotProps"> 
                            <span v-if="slotProps.data.statusDireito.idenStatusAfastamento > 0" class="customer-badge-validado"> {{slotProps.data.statusDireito.constante}}</span>                        
                            <span v-else class="customer-badge-negado"> {{slotProps.data.statusDireito.constante}}</span>
                    </template>
            </Column>   
        </table-seplag> 
    </card-seplag> 
</template>

<script>
import TableSeplag from '@/template/TableSeplag.vue'
import CardSeplag from '@/template/CardSeplag.vue'
import { baseApiUrl } from '@/config/global'
export default {
    name:"feriasChefiaPendenteValidacao",
    components: { TableSeplag,CardSeplag },    
    data: function(){
        return {        
            dadosTabelaNaoValidados: [],
            apiUrlRecurso: "direitoafastamentos",
            urlPaginacao: null,
            totalRegistro: 0,
            tamanhoPorpagina: 10,
            paginacaoTabela: '?size=10&page=0',
            dataAtual: new Date(),
            colunasTabela: [
				{ nome: 'matricula', titulo: 'Matrícula',tamanho:'8.%',alinhamento: 'center' },
				{ nome: 'nome', titulo: 'Nome',tamanho:'30.%',alinhamento: 'center'  },
				{ nome: 'setor', titulo: 'Setor',tamanho:'23.%',alinhamento: 'center'  },
            ],
        }
    },
    methods: {  
		carregarDados(){
            this.urlPaginacao = `${this.apiUrlRecurso}/chefia/naoagendados/${this.$store.getters.getMatricula}/${this.$store.getters.getVinculo}/${this.$store.getters.getIdenPessoa}`
            this.$http.get(`${baseApiUrl}/${this.urlPaginacao}?size=${this.tamanhoPorpagina}&page=0`).then(res => {
               this.dadosTabelaNaoValidados = res.data.content
               this.totalRegistro = res.data.totalElements
            })         
        },
        adicionarRegistro(){
            // this.exibirTela = false
        },
        validateServidor(servidor){
            if(servidor.dataLimiteDireito){
                let date = new Date(servidor.dataLimiteDireito.split('/').reverse().join('/'));
                if(date < this.dataAtual){
                    return false
                }else{
                    return true
                }

            }else{
                return true
            }

        }
    },
    mounted(){
		// Carrega os dados do serviço
		this.carregarDados()
    }
    
}
</script>

<style>
.customer-badge-validado {
    border-radius: 2px;
    padding: .25em .5em;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
    background-color: #C8E6C9;
    color: #256029;
}
.customer-badge-negado {
    border-radius: 2px;
    padding: .25em .5em;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
    background-color: #FFCDD2;
    color: #C63737;
}
</style>